import * as angular from 'angular';
import { ng } from '@uirouter/angularjs/lib/angular';

directive.$inject = ['$parse'];
function directive($parse: ng.IParseService): ng.IDirective {

    return {
        restrict: 'A',
        link: linkFn
    };

    function linkFn(scope: ng.IScope, instance: JQLite, attrs: ng.IAttributes) {
        let fn = $parse(attrs.whenScrolled);
        if (!fn) {
            console.log('function required');
            return;
        }
        let elem = instance[0];
        elem.addEventListener('scroll', function() {
            if (elem.scrollTop + elem.offsetHeight >= elem.scrollHeight) {
                scope.$applyAsync(fn);
            }
        });
    }
}

angular
    .module('app.common')
    .directive('whenScrolled', directive);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/ng-when-scrolled.ts